import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';


/**
 * @version $Id: header.component.ts 148545 2019-09-11 17:59:15Z thiago.h.neri $
 */
 
@Injectable()
export class CanEnterSyncGuard implements CanActivate {
 private vivoSyncOnOff: boolean =false;

 
  canActivate(): Observable<boolean> {
      return Observable.create((observer: Observer<boolean>) => {
        let data = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
        if (data!=null) {
            this.vivoSyncOnOff = data['vivoSyncOnOff'];
        }
        if(this.vivoSyncOnOff){
              observer.next(this.vivoSyncOnOff);
              observer.complete();
        }else{
             observer.next(false);
                 observer.complete();
        }
      });
  }    
}




// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/header/canentersyncguard/content.component.ts